var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiverFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 72.237c3.488-9.672 12.748-16.586 23.623-16.586 11.364 0 20.965 7.551 24.058 17.91-5.917 5.991-14.136 9.704-23.222 9.704-9.738 0-18.48-4.264-24.459-11.028Z",
    fill: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.134 50.247 3.955-9.254h35.163l4.396 9.768c-.44.343-5.002 2.464-9.573 3.287-5.714 1.028-12.98 1.384-20.452.87-5.978-.411-11.749-3.481-13.49-4.67Z",
    fill: "#757F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.357 26.635a5.657 5.657 0 0 1 5.657-5.657h21.757a5.657 5.657 0 0 1 5.657 5.657v11.748c0 9.133-7.403 16.536-16.535 16.536-9.133 0-16.536-7.403-16.536-16.535v-11.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.717 30.162c3.48-1.74 7.397-5.221 9.137-7.833 1.306 3.047 2.558 5.264 3.917 6.963 1.74 2.176 3.917 5.222 6.963 5.657v-9.573c0-8.314-10.458-12.74-20.452-12.184-15.664.87-15.665 14.795-15.665 21.322 5.656.435 12.619-2.611 16.1-4.352Z",
    fill: "#757F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.67 47.52a3.046 3.046 0 0 1 3.046-3.045h2.611a3.046 3.046 0 0 1 3.046 3.046v10.878a4.351 4.351 0 0 1-8.703 0V47.521Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.961,
    cy: 39.118,
    rx: 4.069,
    ry: 5.086,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.203,
    cy: 39.12,
    rx: 4.069,
    ry: 5.086,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.863,
    cy: 46.651,
    r: 1.305,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.053,
    cy: 46.651,
    r: 1.305,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909EB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverFemaleIcon);
export default __webpack_public_path__ + "static/media/receiver-female-icon.0fcd863f2eff745a4a9cb19fef0b8042.svg";
export { ForwardRef as ReactComponent };